import "core-js/modules/es.error.cause.js";

/**
 * 请求远程地址，统一封装
 */
export const request = ({
  url,
  method = 'POST',
  headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  query = null,
  body = null,
  beforeSend = null // 发送请求之前可通过此函数加入自定义处理

} = {}) => {
  if (!url) {
    return Promise.reject(new Error('URL 未设置'));
  }

  headers = { ...headers
  };

  if (query) {
    const queryStr = Object.keys(query).map(key => `${key}=${query[key]}`).join('&');
    url += url.indexOf('?') > -1 ? `&${queryStr}` : `?${queryStr}`;
  }

  if (body) {
    const contentType = headers['Content-Type'] || 'application/x-www-form-urlencoded';

    if (contentType.indexOf('form-data') > -1) {
      const formData = new FormData();
      Object.keys(body).forEach(key => {
        formData.append(key, body[key]);
      });
      body = formData;
      delete headers['Content-Type'];
    } else if (contentType.indexOf('x-www-form-urlencoded') > -1) {
      body = Object.keys(body).map(key => `${key}=${body[key]}`).join('&');
    }
  }

  const req = {
    method,
    url: url,
    headers,
    body,
    credentials: 'include'
  };

  if (beforeSend) {
    beforeSend(req);
  }

  return fetch(req.url, req).then(res => res.json());
};